import { useEffect } from 'react';

import useOrgRoleStaffRoleHierarchyData from '../../../state/orgRoleStaffRoleHierarchy/UseOrgRoleStaffRoleHierarchyData';

const useOrgRoleStaffRoleTreeView = (roleGroupId, excludeRegistrationRoles, excludeRegistrationRolesWithoutChildren) => {
  const { orgRoleStaffRoleHierarchyState, getOrgRolesStaffRolesHierarchy } = useOrgRoleStaffRoleHierarchyData();

  useEffect(() => {
    if (roleGroupId > 0 && orgRoleStaffRoleHierarchyState.roleGroupId !== roleGroupId &&
      orgRoleStaffRoleHierarchyState.isArrayLoading === false) {
      getOrgRolesStaffRolesHierarchy(roleGroupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleGroupId]);

  function getOptionsForTreeView(excludeRegistrationRoles, excludeRegistrationRolesWithoutChildren) {
    if (excludeRegistrationRoles === true) {
      return orgRoleStaffRoleHierarchyState.treeDataNoRegistrationRoles;
    } else if (excludeRegistrationRolesWithoutChildren === true) {
      return orgRoleStaffRoleHierarchyState.treeDataNoRegistrationRolesWithoutChildren;
    } else {
      return orgRoleStaffRoleHierarchyState.treeData;
    }
  }

  return {
    orgRoleStaffRoleHierarchyState,
    options: getOptionsForTreeView(excludeRegistrationRoles, excludeRegistrationRolesWithoutChildren) || [],
  };
};

export default useOrgRoleStaffRoleTreeView;